module.exports = __webpack_public_path__ + "img/Kibe76.97cbb477.jpg";